import { render, staticRenderFns } from "./DetialOfKnowledge.vue?vue&type=template&id=1b2f4873&scoped=true"
import script from "./DetialOfKnowledge.vue?vue&type=script&lang=js"
export * from "./DetialOfKnowledge.vue?vue&type=script&lang=js"
import style0 from "./DetialOfKnowledge.vue?vue&type=style&index=0&id=1b2f4873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f4873",
  null
  
)

export default component.exports